/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FirmwareS3Request
 */
export interface FirmwareS3Request {
    /**
     * 
     * @type {string}
     * @memberof FirmwareS3Request
     */
    s3Url: string;
    /**
     * 
     * @type {boolean}
     * @memberof FirmwareS3Request
     */
    isByCredentials: boolean;
    /**
     * 
     * @type {string}
     * @memberof FirmwareS3Request
     */
    accessKey: string | null;
    /**
     * 
     * @type {string}
     * @memberof FirmwareS3Request
     */
    secretKey: string | null;
}

export function FirmwareS3RequestFromJSON(json: any): FirmwareS3Request {
    return FirmwareS3RequestFromJSONTyped(json, false);
}

export function FirmwareS3RequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FirmwareS3Request {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        's3Url': json['s3Url'],
        'isByCredentials': json['isByCredentials'],
        'accessKey': json['accessKey'],
        'secretKey': json['secretKey'],
    };
}

export function FirmwareS3RequestToJSON(value?: FirmwareS3Request | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        's3Url': value.s3Url,
        'isByCredentials': value.isByCredentials,
        'accessKey': value.accessKey,
        'secretKey': value.secretKey,
    };
}

